import InformationModal from './component'

export default InformationModal
